const n=t=>t&&t.filter(({style:e})=>!(typeof e=="number"||typeof e=="string"&&!Number.isNaN(Number(e))));export{n as removeInvalidInlineStyles};
//# sourceMappingURL=removeInvalidInlineStyles.js.map
